import { ResourceState } from '@mews-commander/data-access';
import { CoProduct, Identifiable, Optional, Unit, UpdateValue } from '@mews/std';
import { ASSIGNEE_PROFILE_ID_NAME, RESOURCE_IDS_NAME } from '../constants';
import { ResourceDataDiscriminator } from '../enums';

export interface ResourcesGetAllExtent {
    resources?: boolean;
    slots?: boolean;
    resourceCategoryAssignments?: boolean;
    resourceCategories?: boolean;
    resourceFeatures?: boolean;
}

export interface ResourcesGetAllParameters {
    enterpriseId: string;
    extent?: ResourcesGetAllExtent;
}

export interface ResourceUpdateParameters {
    resourceId: string;
    assigneeProfileId?: UpdateValue<string>;
    state?: UpdateValue<string>;
    stateReason?: UpdateValue<string>;
}

export interface ResourcesSpaceDataValue {
    floorNumber: string;
}

export type ResourceSpaceCoProduct = CoProduct<ResourceDataDiscriminator.Space, ResourcesSpaceDataValue>;
export type ResourceObjectCoProduct = CoProduct<ResourceDataDiscriminator.Object, Unit>;
export type ResourcePersonCoProduct = CoProduct<ResourceDataDiscriminator.Person, Unit>;

export type ResourceCoProducts = ResourceSpaceCoProduct | ResourceObjectCoProduct | ResourcePersonCoProduct;

export interface Resource extends Identifiable {
    parentId: Optional<string>;
    assigneeProfileId?: string;
    name: string;
    state: ResourceState;
    stateReason: string;
    stateReasonClassification: ResourceStateReasonClassification;
    data: ResourceCoProducts;
    minX: number;
    maxX: number;
    minY: number;
    maxY: number;
    resourceCategoryId: string;
}

export enum ResourceStateReasonClassification {
    Other = 'Other',
    SkipCleaning = 'SkipCleaning',
}
export interface ResourceAssignmentFormValues {
    [RESOURCE_IDS_NAME]: string[];
    [ASSIGNEE_PROFILE_ID_NAME]: string;
}

export interface ResourceStateUpdate {
    resourceId: string;
    state?: ResourceState;
    stateReason?: string;
}
